<template>
  <ThemeSliderSmall
    :top-title="mgnlPropsWithBtnColors.topTitle"
    :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
    :cta-text-color="mgnlPropsWithBtnColors.ctaTextColor"
    :cta-link="mgnlPropsWithBtnColors.ctaLink"
    :slides="mgnlPropsWithBtnColors.slides"
    :data-ab-id="mgnlProps?.dataABId"
    :legal-text="mgnlProps?.legalText"
    :legal-title="mgnlProps?.legalTitle"
    :enable-legal-disclaimer="mgnlProps?.enableLegalDisclaimer"
  />
</template>

<script lang="ts" setup>
import { ThemeSliderSmallBuilder, WrapperProps } from './ThemeSliderSmall.model';
import ThemeSliderSmall from './ThemeSliderSmall.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps({
  ...WrapperProps, pageLink: Object, ctaText: String, ctaTargetMode: String, pdfLinkInDam: Object, showCtaAsPdf: Boolean,
});

const { topTitleColor, imageLoadType } = toRefs(props);
provide('imageLoadType', imageLoadType?.value ?? 'lazy');

const mgnlProps = {
  ...ThemeSliderSmallBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
};

if (props.pageLink && !props.ctaLink) {
  magnoliaGetters.migratePageLinkToCtaLink(mgnlProps, props);
}

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctaTextColor: mgnlProps.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.ctaTextColor) : '#ffffff',
  slides: mgnlProps?.slides?.map(slide => ({
    ...slide,
    titleColor: magnoliaGetters.getHexColor(slide.titleColor),
    subTitleColor: magnoliaGetters.getHexColor(slide.subTitleColor),
  })),
};
</script>
